/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/postFeatureFlagStatusesQueryOverrides';

export type PostFeatureFlagStatusesQueryPathParams = NonNullable<
  operations['postFeatureFlagStatusesQuery']['parameters']['path']
>;

export type PostFeatureFlagStatusesQueryRequestBody = OperationRequestBodyContent<
  operations['postFeatureFlagStatusesQuery']
>;

export interface Input extends PostFeatureFlagStatusesQueryPathParams {
  apiVersion?: string;
  body: PostFeatureFlagStatusesQueryRequestBody;
}

export async function postFeatureFlagStatusesQuery(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().POST('/api/v2/projects/{projectKey}/flag-statuses/query', {
    params: { path },
    body,
    headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
    signal,
  });
}
